import React, { Component } from "react";
import Content from "../../../content/Content";
import style from "../../../assets/css/modules/shared/status-panel.css";

export default class StatusPanel extends Component {
  render() {
    let statusColour = style.green;
    if (this.props.statusColour) {
      if (this.props.statusColour === "red") {
        statusColour = style.red;
      } else if (this.props.statusColour === "blue") {
        statusColour = style.blue;
      }
    }
    return (
      <div className={style.status + " " + statusColour}>
        <div className={style.statusText}>
          <Content name={this.props.text} />
        </div>
      </div>
    );
  }
}
